import { Serie } from "@/types/serie";

export const convertSeriesDataToHighchartsSeries = (serie: Serie): [Date, number][] => {
  return Object.entries(serie.data).map(([dateStr, value]) => {
    return [new Date(dateStr), value];
  });
};

export const replaceParametersInUrl = (url: string): string => {
  if (url.match(/%BASE_URL%/)) {
    // Since the old widget configs return a URL with %BASE_URL% in it, we need to replace it with an empty string
    return url.replace(/%BASE_URL%/, "");
  }

  return url;
};
